import React, { useState, useRef } from "react";
import arrow from "../assets/arrow.svg"

const FAQSection = () => {
    const faqs = [
        {
            question: "What are the eligibility requirements to apply?",
            answer: "",
        },
        {
            question: "How does the $10,000 SAFE-based funding work?",
            answer: "",
        },
        {
            question: "Do I need to have a co-founder to join the program?",
            answer: "",
        },
        {
            question: "What kind of AI-powered tools will I have access to?",
            answer: "",
        },
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const contentRefs = useRef([]);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <m className="subheading">Need More Info?</m>
            <h1 className="heading">Still Have Questions?<br />We Have Answers</h1>

            <div className="faq-list">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <button className="faq-question" onClick={() => toggleFAQ(index)}>
                            {faq.question}
                            <span className={`arrow ${openIndex === index ? "open" : ""}`}><img src={arrow} alt="arrow" /></span>
                        </button>
                        <div
                            className="faq-answer-wrapper"
                            ref={(el) => (contentRefs.current[index] = el)}
                            style={{
                                maxHeight: openIndex === index ? `${contentRefs.current[index]?.scrollHeight}px` : "0px",
                                overflow: "hidden",
                                transition: "max-height 0.3s ease-in-out",
                            }}
                        >
                            <p className="faq-answer">{faq.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FAQSection;